import axios from 'axios'
import { useAuthStore } from '../stores/auth'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://localhost:7001/api',
  withCredentials: true
})

api.interceptors.request.use((config) => {
  const auth = useAuthStore()
  if (auth.accessToken) {
    config.headers.Authorization = `Bearer ${auth.accessToken}`
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const auth = useAuthStore()
    const original = error.config
    const authEndpoints = ['/auth/register', '/auth/login', '/auth/refresh', '/auth/logout']
    const isAuthEndpoint = authEndpoints.some((url) => original?.url?.startsWith(url))

    if (error.response?.status === 401 && auth.accessToken && !isAuthEndpoint && !original._retry) {
      original._retry = true
      await auth.refresh()
      original.headers.Authorization = `Bearer ${auth.accessToken}`
      return api(original)
    }
    return Promise.reject(error)
  }
)
